import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { ProjectScanStatistics } from '@portal-core/reports/models/project-scan-statistics.model';

@CollectionStateSelectors({
  stateType: ProjectScanStatisticsState
})
@State<ProjectScanStatisticsState>({
  name: ProjectScanStatisticsState.source
})
@Service({ autoProvided: false })
export class ProjectScanStatisticsState extends CollectionStateBase {
  static override source = 'ProjectScanStatistics';
  getSource(): string {
    return ProjectScanStatisticsState.source;
  }
}

@Service()
export class ProjectScanStatisticsDataService extends CollectionDataServiceBase<ProjectScanStatistics> {
  protected readonly stateType = ProjectScanStatisticsState;
}
